// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.process-content-sqTXSy{white-space:break-spaces;width:100%;padding:12px;font-size:12px;font-weight:400;line-height:15px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"process-content": `process-content-sqTXSy`,
	"processContent": `process-content-sqTXSy`
};
export default ___CSS_LOADER_EXPORT___;
